import { manufacturingFetch } from "@/lib/manufacturingClient";
import type { OpportunityDocument } from "@/lib/opportunity/opportunityDocumentsClient";
import type { ServiceOfferingDocument, ServiceRequest, ServiceWorkQueue } from "./types";

export type ServiceRequestIntakeAttachment = {
  id: string;
  filename: string;
  content_type: string;
  signed_url?: string;
};

export type ServiceRequestApprovalContext = {
  offering_label: string | null;
  offering_documents: ServiceOfferingDocument[];
  opportunity_documents: OpportunityDocument[];
  intake_attachments: ServiceRequestIntakeAttachment[];
};

export function getServiceRequestApprovalContext(requestId: string) {
  const q = new URLSearchParams({ request_id: requestId });
  return manufacturingFetch<{ ok: true } & ServiceRequestApprovalContext>(
    `/api/service/requests/approval-context?${q.toString()}`,
    { method: "GET" }
  );
}

export type ServiceRequestOperationalDraft = {
  description: string;
  location_label: string;
  location_address: string;
  queue_id: string | null;
};

export function draftFromServiceRequest(req: ServiceRequest): ServiceRequestOperationalDraft {
  return {
    description: req.description ?? "",
    location_label: req.location_label ?? "",
    location_address: req.location_address ?? "",
    queue_id: req.queue_id,
  };
}

export function patchServiceRequestOperational(payload: {
  request_id: string;
} & Partial<ServiceRequestOperationalDraft>) {
  return manufacturingFetch<{ ok: true; request: ServiceRequest }>("/api/service/requests/patch", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function formatQuotedAmount(cents: number | null | undefined): string {
  if (cents == null) return "—";
  return `$${(cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function queueOptions(queues: ServiceWorkQueue[], selectedId: string | null) {
  const active = queues.filter((q) => q.is_active);
  const selectedInactive =
    selectedId && !active.some((q) => q.id === selectedId)
      ? queues.find((q) => q.id === selectedId)
      : null;
  return selectedInactive ? [...active, selectedInactive] : active;
}
